import { getPriorityIcon } from "@utils/priority"

import { Skeleton } from "@particles/index"

import { Icon } from "@atoms"

import { useJobPreviewCard } from "@pages/Jobs/JobList/views/JobTimelineView/JobPreviewCard/JobPreviewCard.context"

import styles from "./JobPreviewPriority.module.scss"
import { JobPreviewPriorityProps } from "./JobPreviewPriority.types"

export default function JobPreviewPriority(props: JobPreviewPriorityProps) {
    const { priority } = props
    const { isLoading } = useJobPreviewCard()

    if (isLoading && priority === undefined) {
        return <Skeleton width={16} height={16} circle={true} />
    }

    return (
        <Icon
            icon={getPriorityIcon(priority ?? null)}
            size={8}
            containerClassName={priority === 1 ? styles.urgentPriorityIcon : styles.priorityIcon}
        />
    )
}
